import React from 'react';
import './BaseInput.scss'
import {useSelector, useDispatch} from 'react-redux'
import {setForm} from "../../store/slices/invoiceSlice";

export default function BaseInput({inputType, icon, label, inputId, dropdownIcon, onClickDropdown}) {
    const dispatch = useDispatch()
    const initialValue = useSelector(state => state.invoice.invoiceForm[inputId])

    if (inputType === 'checkbox') {
        return (<div className={'flex items-start justify-between'}>
            <div className={'flex items-start justify-start w-4/5'}>
                {icon && <div className={'w-2/12 flex justify-center'}>
                    <img className={'w-3/5'} src={`img/${icon}.png`} alt=""/>
                </div>}
                <label className={'w-9/12 text-gray-600 font-normal label-text normal-case pl-3'}
                       htmlFor={inputId}>{label}</label>
            </div>
            <input type='checkbox'
                   name={inputId} key={inputId}
                   defaultChecked={initialValue}
                   onInput={(e) => dispatch(setForm({field: inputId, value: e.target.checked}))}
            />
        </div>)
    }
    return (<div className="input-border field py-1 px-3 pt-1 relative">
        <input type={inputType ? inputType : 'text'} id={inputId}
               placeholder=" " key={inputId} value={initialValue}
               onInput={(e) => dispatch(setForm({field: inputId, value: e.target.value}))}
        />
        <label className={'text-gray-600 text-xs normal-case'}
               htmlFor={inputId}>{label}</label>
        {dropdownIcon && <div className={'absolute right-2 top-1/3'}>
            <img onClick={onClickDropdown} src={`img/arrow-down.png`} alt=""/>
        </div>}
    </div>);
}
